import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { usePriceGroup } from 'core/contexts/priceGroup';
import { BookingOrigin } from '@utriper/core';
import { Form } from 'react-final-form';
import { Box, FormHelperText } from '@mui/material';
import ActionButtons from '../ActionButtons';
import Title from 'modules/Pricing/components/Title';

const DeleteOrigin = ({ priceGroupId, handleClose = () => {}, bookingOriginId }) => {
    const { t, i18n } = useTranslation();
    const translate = (key, options) => t(`price_group_id.delete_origin_form.${key}`, options);
    const { submittingPriceGroup, deleteBookingOrigin } = usePriceGroup();
    const originName = useMemo(() => {
        if (!bookingOriginId) return '';

        return BookingOrigin.getTranslatedName(BookingOrigin.types, bookingOriginId, i18n.language);
    }, [bookingOriginId, i18n.language]);

    const handleSubmit = async (values) => {
        await deleteBookingOrigin(priceGroupId, bookingOriginId);
        handleClose();
    };

    const validateForm = (values) => {
        const errors = {};

        if (!values?.bookingOriginId || !BookingOrigin.isValidId(values?.bookingOriginId)) errors.bookingOriginId = translate('validate_form.required');

        return errors;
    };

    if (!bookingOriginId || !BookingOrigin.isValidId(bookingOriginId)) {
        handleClose();
        return;
    }

    return (
        <Form
            key={`delete-price-group-origin-${bookingOriginId}`}
            onSubmit={handleSubmit}
            validate={validateForm}
            initialValues={{ bookingOriginId }}
            render={({ errors, handleSubmit, form }) => (
                <form key={`delete-price-group-origin-${bookingOriginId}`} onSubmit={handleSubmit} noValidate>
                    <Box component="section" py={2}>
                        <Title title={translate('title', { origin: originName })} description={translate('description', { origin: originName })} />

                        {errors?.bookingOriginId && (
                            <FormHelperText error sx={{ my: 1 }}>
                                {errors.bookingOriginId}
                            </FormHelperText>
                        )}

                        <ActionButtons
                            handleSubmit={(e) => handleSubmit(e)}
                            handleClose={(e) => {
                                handleClose();
                                return form.reset(e);
                            }}
                            submitting={submittingPriceGroup}
                            labelNext={translate('delete')}
                        />
                    </Box>
                </form>
            )}
        />
    );
};

export default DeleteOrigin;
